import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Table,
  Modal,
  Form,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

import { BsPencilSquare, BsTrash, BsPlusLg } from "react-icons/bs";

import SuperAdminSidebar from "./SuperAdminSidebar";
import Topbar from "./Topbar";



function TradeTypes() {
  const [tradeTypes, setTradeTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [typeName, setTypeName] = useState("");
  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  const fetchTradeTypes = async () => {
    try {
      const response = await axios.get(`${API_URL}list-all-trade-types.php`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.status && Array.isArray(response.data.data)) {
        setTradeTypes(response.data.data);
      } else {
        setTradeTypes([]);
      }
    } catch (error) {
      toast.error("Could not fetch trade types.");
    }
  };

  useEffect(() => {
    fetchTradeTypes();
  }, []);

  const handleShowModal = (type = null) => {
    if (type) {
      setIsEditMode(true);
      setSelectedType(type);
      setTypeName(type.trade_type_name);
    } else {
      setIsEditMode(false);
      setSelectedType(null);
      setTypeName("");
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowDeleteModal = (type) => {
    setSelectedType(type);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedType(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = isEditMode
      ? `${API_URL}update-trade-type.php`
      : `${API_URL}add-trade-type.php`;
    const payload = {
      id: isEditMode ? selectedType.id : undefined,
      trade_type_name: typeName,
    };
    try {
      const response = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.status) {
        toast.success(response.data.message);
        fetchTradeTypes();
        handleCloseModal();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("An operation failed.");
    }
  };

  const handleDelete = async () => {
    try {
      const response = await axios.post(
        `${API_URL}delete-trade-type.php?id=${selectedType.id}`,
        { id: selectedType.id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.status) {
        toast.success(response.data.message);
        fetchTradeTypes();
        handleCloseDeleteModal();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Failed to delete trade type.");
    }
  };

  return (
    <>
      <Topbar />
      <div className="d-flex">
        <SuperAdminSidebar />
        <Container fluid className="p-4 bg-light">
          <Row>
            <Col>
              <Card className="shadow-sm">
                <Card.Header
                  as="h5"
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    backgroundColor: "#e3f2fd",
                    borderBottom: "2px solid #1976d2",
                  }}
                >
                  <span style={{ color: "#1976d2" }}>Manage Trade Types</span>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => handleShowModal()}
                  >
                    <BsPlusLg className="me-2" />
                    Add New Trade Type
                  </Button>
                </Card.Header>
                <Card.Body>
                  <div className="table-responsive">
                    <Table striped bordered hover>
                      <thead className="table-dark">
                        <tr>
                          <th>#</th>
                          <th>Trade Type Name</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tradeTypes.length > 0 ? (
                          tradeTypes.map((type, index) => (
                            <tr key={type.id}>
                              <td>{index + 1}</td>
                              <td>{type.trade_type_name}</td>
                              <td>
                                <Button
                                  variant="warning"
                                  size="sm"
                                  className="me-2"
                                  onClick={() => handleShowModal(type)}
                                >
                                  <BsPencilSquare />
                                </Button>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => handleShowDeleteModal(type)}
                                >
                                  <BsTrash />
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center">
                              No trade types found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? "Edit Trade Type" : "Add New Trade Type"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Trade Type Name</Form.Label>
              <Form.Control
                type="text"
                value={typeName}
                onChange={(e) => setTypeName(e.target.value)}
                placeholder="Enter trade type name"
                required
                autoFocus
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              {isEditMode ? "Save Changes" : "Create Type"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the trade type "
          <strong>{selectedType?.trade_type_name}</strong>"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TradeTypes;
